import 'src/global.css';

import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import { useModalFocusRestoration } from 'src/hooks/use-modal-focus-restoration';

import { SignalRProvider } from 'src/signalr'
// import { CONFIG } from 'src/config-global';
import { LocalizationProvider } from 'src/locales';
import { I18nProvider } from 'src/locales/i18n-provider';
import { ThemeProvider } from 'src/theme/theme-provider';

import { Snackbar } from 'src/components/snackbar';
import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { CheckoutProvider } from 'src/sections/checkout/context';

import { AuthProvider as JwtAuthProvider } from 'src/auth/context/jwt';

// import { AuthProvider as Auth0AuthProvider } from 'src/auth/context/auth0';
// import { AuthProvider as AmplifyAuthProvider } from 'src/auth/context/amplify';
// import { AuthProvider as SupabaseAuthProvider } from 'src/auth/context/supabase';
// import { AuthProvider as FirebaseAuthProvider } from 'src/auth/context/firebase';

// ----------------------------------------------------------------------

const AuthProvider =
  // (CONFIG.auth.method === 'amplify' && AmplifyAuthProvider) ||
  // (CONFIG.auth.method === 'firebase' && FirebaseAuthProvider) ||
  // (CONFIG.auth.method === 'supabase' && SupabaseAuthProvider) ||
  // (CONFIG.auth.method === 'auth0' && Auth0AuthProvider) ||
  JwtAuthProvider;

export default function App() {
  useScrollToTop();
  useModalFocusRestoration();

  return (
    <I18nProvider>
      <LocalizationProvider>
        <AuthProvider>
          <SignalRProvider>
            <SettingsProvider settings={defaultSettings}>
              <ThemeProvider>
                <MotionLazy>
                  <CheckoutProvider>
                    <Snackbar />
                    <ProgressBar />
                    <SettingsDrawer />
                    <Router />
                  </CheckoutProvider>
                </MotionLazy>
              </ThemeProvider>
            </SettingsProvider>
          </SignalRProvider>
        </AuthProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
